import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Import your page components
import LoginPage from "../pages/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import ProductsPage from "../pages/ProductsPage";
import SalesPage from "../pages/SalesPage";
import ReportsPage from "../pages/ReportsPage";
import AddProductPage from "../pages/AddProductPage";
import EditProductPage from "../pages/EditProductPage";
import SettingsPage from "../pages/SettingsPage";
import RenewLicensePage from "../pages/RenewLicensePage";
import PaymentPage from "../pages/PaymentPage"; // ← FIXED
import PaymentSuccessPage from "../pages/PaymentSuccessPage";

// → Add this import
import RegisterPage from "../pages/RegisterPage";   // ← make sure this file exists

// Import the self-contained ProtectedRoute component
import ProtectedRoute from "./ProtectedRoute";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes - no login required */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />           {/* ← NEW */}

      {/* Protected Routes - require authentication */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />

      {/* --- Product Related Routes --- */}
      <Route
        path="/products"
        element={
          <ProtectedRoute>
            <ProductsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/add"
        element={
          <ProtectedRoute>
            <AddProductPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/edit/:id"
        element={
          <ProtectedRoute>
            <EditProductPage />
          </ProtectedRoute>
        }
      />

      {/* --- Other Protected Routes --- */}
      <Route
        path="/sales"
        element={
          <ProtectedRoute>
            <SalesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <ProtectedRoute>
            <ReportsPage />
          </ProtectedRoute>
        }
      />

      {/* --- Settings Route --- */}
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />

        <Route path="/renew-license" element={<RenewLicensePage />} />

        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />

      {/* Catch-all: redirect unknown paths to login */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;